import React from 'react'
import Navbar from './Navbar'
import Login from './Login'
import Splash from './Splash'

function Home() {
  return (
    <div>
      <Splash/>
    </div>
  )
}

export default Home
